import { defaultFill } from '../../utils/constants';
var muiNotification16 = {
    paths: [
        {
            path: 'M6,0 C6.55228475,0 7,0.442660332 7,0.998956561 L7,1.09963461 C9.28224032,1.56123811 11,3.57291137 11,6.00218626 L11.0005677,11.0000045 C11.55282,11.0016263 12,11.4448834 12,12 C12,12.5522847 11.544239,13 10.9975267,13 L10.9975267,13 L8,13 C8,14.1045695 7.1045695,15 6,15 C4.8954305,15 4,14.1045695 4,13 L4,13 L1.00247329,13 C0.448822582,13 0,12.5561352 0,12 C0,11.4477153 0.455760956,11 1.00247329,11 L1,11 L1,6.00218626 C1,3.58273837 2.72126348,1.56448187 5,1.10038828 L5,0.998956561 C5,0.447248087 5.44386482,0 6,0 Z M6,3 C4.34314575,3 3,4.34314575 3,6 L3,11 L9,11 L9,6 C9,4.34314575 7.65685425,3 6,3 Z',
            fill: defaultFill,
        },
    ],
    title: 'Notification',
    width: 12,
    height: 15,
};
var muiNotification24 = {
    paths: [
        {
            path: 'M12,2.24309718 C15.4504544,3.0996825 18,6.1207303 18,9.71549704 L18,18 L18.4967494,18 C19.3269718,18 20,18.6657972 20,19.5 C20,20.3284271 19.3345642,21 18.4967494,21 L13,21 C13,22.6568542 11.6568542,24 10,24 C8.34314575,24 7,22.6568542 7,21 L1.5032506,21 C0.673028218,21 0,20.3342028 0,19.5 C0,18.6715729 0.665435791,18 1.5032506,18 L2,18 L2,9.71549704 C2,6.12142845 4.55446179,3.10132794 8,2.24381811 L8,2.00591905 C8,0.898080551 8.88772964,0 10,0 C11.1045695,0 12,0.886554837 12,2.00591905 L12,2.24309718 L12,2.24309718 Z M10,4 C6.6862915,4 4,6.6862915 4,10 L4,18 L16,18 L16,10 C16,6.6862915 13.3137085,4 10,4 Z',
            fill: defaultFill,
        },
    ],
    title: 'Notification',
    width: 20,
    height: 24,
};
var muiNotification = {
    base: muiNotification16,
    smIcon: muiNotification16,
    lgIcon: muiNotification24,
};
export { muiNotification };
//# sourceMappingURL=notification.js.map